import styled from 'styled-components';

export const FaqContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  box-sizing: border-box;
`;

export const FaqGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
`;

export const FaqItem = styled.div`
  cursor: pointer;
  &:hover {
    background-color: #f3f4f8;
  }
`;

export const FaqTrigger = styled.button<{ isActive?: boolean }>`
  width: 100%;
  background: none;
  border: none;

  text-align: left;
  padding: 15px;
  fontweight: bold;
  font-size: 20px;
  ${({ isActive }) =>
    isActive &&
    `
    background-color: #F3F4F8;
  `}
`;

export const FaqContentWrapper = styled.div`
  width: 103%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  min-height: 400px;
  min-width: 100%;
`;

export const FaqContentInner = styled.div`
  width: 800px;
  padding: 15px;
  height: 100%;
  overflow: auto;
`;

export const SubQuestionTrigger = styled.span`
  font-size: 18px;
  padding-left: 24px;
  background: none;
  border: none;
  box-shadow: none;
  padding: 0;
`;
